<script setup lang="ts">
  import type { DividerStoryblok } from '@/storyblok/component-types-sb'
  import { cva } from 'class-variance-authority'

  const props = defineProps<{
    blok: DividerStoryblok
  }>()

  const dividerCva = computed(() =>
    cva('h-px w-full bg-divider', {
      variants: {
        withoutVerticalMargins: {
          true: '',
          false: 'lg:my-8'
        }
      }
    })({
      withoutVerticalMargins: props.blok.withoutVerticalMargins
    })
  )
</script>

<template>
  <section class="md:mx-auto md:w-8/12 lg:w-10/12">
    <div :class="dividerCva" />
  </section>
</template>
